// extracted by mini-css-extract-plugin
export default {"socialMediaCards":"OutreachAndChannels_socialMediaCards__9dK-r","top":"OutreachAndChannels_top__RJvDA","footer":"OutreachAndChannels_footer__Cp0SW"};